import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';
const AMPLITUDE_APP_NAME = 'upgrades';
export const tracker = createTracker({
  events,
  properties: {
    namespace: AMPLITUDE_APP_NAME
  }
});
export const getDeployableName = () => {
  var _window$hubspot;
  // @ts-expect-error the error notes that bender is not defined on the
  // window.hubspot object, but it's documented in the auth docs:
  // https://product.hubteam.com/docs/appsystems/team-os/user-setup-fe/useful-info.html#how-to-check-which-app-your-looking-at
  return ((_window$hubspot = window.hubspot) === null || _window$hubspot === void 0 || (_window$hubspot = _window$hubspot.bender) === null || _window$hubspot === void 0 ? void 0 : _window$hubspot.currentProject) || getApp();
};
const cleanUpEventProperties = (eventProperties = {}) => {
  Object.keys(eventProperties).forEach(property => {
    var _eventProperties$prop;
    if (((_eventProperties$prop = eventProperties[property]) !== null && _eventProperties$prop !== void 0 ? _eventProperties$prop : undefined) === undefined) {
      delete eventProperties[property];
    }
  });
  return eventProperties;
};
const isApiBlackListed = () => {
  return window.location.href.indexOf('sales-iframes') !== -1 || window.location.origin === 'https://preview.hs-sites.com' || window.location.origin === 'https://preview.hs-sitesqa.com';
};
export const track = (eventKey, eventProperties) => {
  if (isApiBlackListed()) {
    return;
  }
  tracker.track(eventKey, cleanUpEventProperties(eventProperties));
};
const getHubAndTier = apiName => {
  const hub = apiName === null || apiName === void 0 ? void 0 : apiName.split('-')[0];
  const tier = apiName === null || apiName === void 0 ? void 0 : apiName.split('-')[2];
  return {
    hub: hub === 'crm' ? 'suite' : hub,
    tier: !tier && hub === 'hubspot' ? 'free' : tier // free tools api name has no tier
  };
};
export const getTrackingProperties = ({
  apiName,
  trackingData
}) => {
  const {
    hub,
    tier
  } = getHubAndTier(apiName);
  return Object.assign({
    app: trackingData.app,
    screen: trackingData.screen,
    subScreen: trackingData.subScreen,
    uniqueId: trackingData.uniqueId,
    apiName,
    source: trackingData.source
  }, trackingData.usageLimitBannerData, {
    hub,
    tier
  });
};